import { Component, inject } from '@angular/core';
import { FirebreakBlockService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  FirebreakBlockCreateDto,
  FirebreakBlockDto,
  FirebreakBlockExcelDownloadDto,
  FirebreakBlockUpdateDto,
} from '../proxy/planning/dtos/firebreak-block';
import { FIREBREAKBLOCK_CONFIG, FIREBREAKBLOCK_FIELDS } from './firebreak-block.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-firebreak-block',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, FirebreakBlockService, ConfirmationService],
  templateUrl: './firebreak-block.html',
  styleUrl: './firebreak-block.scss',
})
export class FirebreakBlock extends BaseHierarchicalCrudComponent<
  FirebreakBlockDto,
  FirebreakBlockCreateDto,
  FirebreakBlockUpdateDto,
  FirebreakBlockExcelDownloadDto
> {
  service = inject(FirebreakBlockService);
  config = FIREBREAKBLOCK_CONFIG;
  fields = FIREBREAKBLOCK_FIELDS;

  protected prepareUpdateDto(data: any, selected: FirebreakBlockDto): FirebreakBlockUpdateDto {
    return {
      gisLandBlockId: data.gisLandBlockId,
      locationId: data.locationId,
      zoneId: data.zoneId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'FirebreakBlock';
  }
}
